import React, { useEffect, useState } from 'react';
import L from 'leaflet'; 
import 'leaflet-draw/dist/leaflet.draw.css';
import 'leaflet/dist/leaflet.css';
import { MapContainer, Marker, TileLayer, GeoJSON, useMap, Tooltip } from 'react-leaflet';
import { LatLngTuple } from 'leaflet';
import camerasData from "../cameras.json";
import styles from "./styles_map.module.css";
import CameraPlayer from "../cameraPlayer/index";
import { Camera } from '../types';

interface IContentPart {
  latitude: number;
  longitude: number;
  onCameraSelect?: (cameraId: number) => void;
}

const customMarkerIcon = L.icon({
  iconUrl: '/camerapage.svg', 
  iconSize: [32, 32],
  iconAnchor: [16, 32],
  popupAnchor: [0, -32],
});

const MapUpdater = ({ center }: { center: LatLngTuple }) => {
  const map = useMap();
  
  useEffect(() => {
    map.setView(center, map.getZoom());
  }, [center, map]);
  
  return null;
};

export const CameraMap = ({ latitude, longitude, onCameraSelect }: IContentPart) => {
  const [center] = useState<LatLngTuple>([latitude, longitude]);
  const [geoData, setGeoData] = useState<any>(null);
  const [activeCamera, setActiveCamera] = useState<Camera | null>(null);

  useEffect(() => {
    const fetchGeoData = async () => {
      try {
        const response = await fetch('/polygons/search.json');
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const data = await response.json();
        if (data[0] && data[0].geojson) {
          setGeoData(data[0].geojson);
        }
      } catch (error) {
       
      }
    };

    fetchGeoData();
  }, []);

  const getStyle = (color: string) => ({
    color: color,
    weight: 2,
    opacity: 1,
    fillOpacity: 0.5,
  });

  const onEachFeature = (feature: any, layer: any) => {
    layer.on({
      mouseover: (e: any) => {
        e.target.setStyle({
          weight: 4,
          fillOpacity: 0.7,
        });
      },
      mouseout: (e: any) => {
        e.target.setStyle({
          weight: 2,
          fillOpacity: 0.5,
        });
      },
    });
  };

  const handleMarkerClick = (camera: Camera) => {
    if (onCameraSelect) {
      onCameraSelect(camera.id);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.mapContainer}>
        <MapContainer
          className={styles.map}
          center={center}
          zoom={10}
          minZoom={6}
          scrollWheelZoom={true}
          zoomControl={true}

        >
          <MapUpdater center={center} />
          
     <TileLayer
         attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
         url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
       />

          {geoData && <GeoJSON data={geoData} style={getStyle('grey')} onEachFeature={onEachFeature} />}

          {camerasData.cameras.map((camera) => (
            <Marker
              key={camera.id}
              position={[camera.coordinates.latitude, camera.coordinates.longitude] as LatLngTuple}
              icon={customMarkerIcon}
              eventHandlers={{
                click: () => handleMarkerClick(camera as Camera)
              }}
            >
              <Tooltip 
                direction="top" 
                offset={[0, -15]} 
                opacity={1}
                permanent={activeCamera?.id === camera.id}
                className={styles.tooltip}
              >
                {camera.name}
              </Tooltip>
            </Marker>
          ))}
        </MapContainer>
      </div>

      {/* <div className={styles.playerWrapper}>
        {activeCamera && (
          <div className={styles.cameraInfo}>
            <h2 className={styles.cameraTitle}>{activeCamera.name}</h2>
          </div>
        )}
      </div> */}
    </div>
  );
};
